<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          span.headline {{ formTitle }}
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12')
                      v-alert( v-if="form.confirmacion" type="success") Pago Confirmado
                      v-alert( v-else type="error") Pago No Confirmado
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12')
                      v-textarea(
                        auto-grow,
                        v-model='form.descripcion',
                        readonly,
                        label="Descripción",
                        outlined,
                        dense,
                        v-uppercase)
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black') Forma de Pago: {{form.idTipoPago.descripcion}}
                v-card-text
                  v-card.mx-auto(max-width='100%', outlined class='px-5')
                    v-container(v-if="form.idTipoPago.descripcion === 'EFECTIVO'")
                      v-row(dense)
                        v-col(cols='6' sm='6' md='6')
                          v-dialog(ref='dialog1' v-model='modalDate1' :return-value.sync='date'  persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field( v-model='form.fechaCobro' readonly label='Fecha de Cobro' prepend-icon='event'  dense outlined v-on='on')
                            v-date-picker( v-model='form.fechaCobro' locale="ES")
                              v-spacer
                              v-btn(small dark color='error' @click='modalDate1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly  v-model.number='form.monto' hint='Ingrese el Monto del efectivo' label="Monto")
                    v-container(v-if="form.idTipoPago.descripcion === 'TRANSFERENCIA'")
                      v-row(dense)
                        v-col(cols='12' sm='12' md='6')
                          v-dialog(ref='dialog2' v-model='modalDate2' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field( v-model='form.fecha' label='Fecha de Transferencia' prepend-icon='event' readonly dense outlined v-on='on')
                            v-date-picker( v-model='form.fecha' locale="ES")
                              v-spacer
                              v-btn(small dark color='error' @click='modalDate2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
                        v-col(cols='12' sm='12' md='6')
                          v-dialog(ref='dialog3' v-model='modalDate3' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field( v-model='form.fechaCobro' label='Fecha de Cobro' prepend-icon='event' readonly dense outlined v-on='on')
                            v-date-picker( v-model='form.fechaCobro' locale="ES")
                              v-spacer
                              v-btn(small dark color='error' @click='modalDate3 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialog3.save(date)') Ok
                      v-row(dense)
                        v-col(cols='12' sm='12' md='6')
                          v-text-field(dense label="Banco" readonly outlined v-model='form.idBanco.nombre')
                        v-col(cols='12' sm='12' md='6')
                          v-text-field(dense outlined readonly v-model='form.referencia' label='Nro. Referencia')
                      v-row(dense class='d-flex justify-end')
                        v-col(cols='12' sm='12' md='6')
                          v-text-field(dense outlined readonly v-model.number='form.monto' label="Monto")
                    v-container(v-if="form.idTipoPago.descripcion === 'CHEQUE'")
                      v-row(dense)
                        v-col(cols='6' sm='6' md='6')
                          v-dialog(ref='dialog4' v-model='modalDate4' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field( v-model='form.fecha' label='Fecha de Cheque' prepend-icon='event' readonly dense outlined v-on='on')
                            v-date-picker( v-model='form.fecha' locale="ES")
                              v-spacer
                              v-btn(small dark color='error' @click='modalDate4 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialog4.save(date)') Ok
                        v-col(cols='6' sm='6' md='6')
                          v-dialog(ref='dialog5' v-model='modalDate5' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field( v-model='form.fechaCobro' label='Fecha de Cobro' prepend-icon='event' readonly dense outlined v-on='on')
                            v-date-picker( v-model='form.fechaCobro' locale="ES")
                              v-spacer
                              v-btn(small dark color='error' @click='modalDate5 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialog5.save(date)') Ok
                      v-row(dense)
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense label="Banco" readonly outlined v-model='form.idBanco.nombre')
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly v-model='form.numeroCheque' label='Nro. Cheque')
                      v-row(dense class='d-flex justify-end')
                        v-col(cols='6' sm='6' md='6')
                          v-text-field(dense outlined readonly v-model.number='form.monto' hint='Ingrese el Monto del cheque' label="Monto")
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close')
            v-icon mdi-close
            | Cancelar
          v-btn(v-if="!form.confirmacion" color='success' small dark @click='save')
            v-icon
            | confirmar Cobro
</template>
<script>
import Api from '@/services/methods'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    ban: false,
    search: '',
    cuentaXCobrar: [],
    permisosRuta: {},
    modalDate1: false,
    modalDate2: false,
    modalDate3: false,
    modalDate4: false,
    modalDate5: false,
    dialog1: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialog5: false,
    date: new Date().toISOString().substr(0, 10),
    form: {
      idCuentaPorCobrar: '',
      idConcepto: '',
      idBanco: '',
      idTipoPago: '',
      idVenta: '',
      monto: 0,
      descripcion: '',
      referencia: '',
      numeroCheque: '',
      fechaRegistro: '',
      fechaCobro: '',
      fecha: '',
      confirmacion: false
    },
    defaultItem: {
      idCuentaPorCobrar: '',
      idConcepto: '',
      idBanco: '',
      idTipoPago: '',
      idVenta: '',
      monto: 0,
      descripcion: '',
      referencia: '',
      numeroCheque: '',
      fechaRegistro: '',
      fechaCobro: '',
      fecha: '',
      confirmacion: false
    }
  }),

  computed: {
    formTitle () {
      return 'Pagos'
    }
  },

  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        // this.form.descripcion = ''
      }, 300)
      this.$emit('close')
    },

    save () {
      this.form.confirmacion = true
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      Api.put('pago', this.form)
        .then(response => {
          this.$emit('edited')
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
      this.close()
    }
  }
}
</script>
